import "./StrategyBuilderStockDetailComponent.scss";
import {IComponentOptions} from "angular";
import {Stock} from "../../models/Stock";

export const StockDetail = "tfStrategyBuilderStockDetail";

export function stockDetail(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/stock-detail/StrategyBuilderStockDetailComponent.html`,
        bindings: {
            stock: "<"
        },
        controllerAs: "ctrl",
        controller: StrategyBuilderStockDetailComponentController
    };
}

export class StrategyBuilderStockDetailComponentController {
    public stock: Stock;
}
